import { useState } from "react";
// MUI
import { Button as MUIButton, Dialog, DialogActions, DialogContent, DialogContentText, IconButton, Stack, Typography } from "@mui/material";

// Hooks
import { useClearFilterStateStore } from "@Common/hooks/TableFilterStore/useClearFilterStateStore";

// Components
import Button from "@Layouts/components/Buttons/Button";

// Icons
import CloseIcon from "@mui/icons-material/Close";

// Constants
import { tableKeys } from "@Constants/tableKeys";

type ClearSelectionButtonProps = Readonly<{
	hasFilteredItems: boolean;
	onClearSelection: () => void;
}>;
export default function ClearSelectionButton(props: ClearSelectionButtonProps) {
	const { hasFilteredItems, onClearSelection } = props;

	// States
	const [isOpenConfirmationDialog, setIsOpenConfirmationDialog] = useState(false);

	// Hooks
	const { clearFilterStateStore } = useClearFilterStateStore(tableKeys.DATA_PAGES.DEALER_INVENTORY);

	/********************************************* HANDLERS ************************************************/
	const handleClearSelection = () => {
		setIsOpenConfirmationDialog(true);
	};

	const handleCancelAlert = () => {
		setIsOpenConfirmationDialog(false);
	};

	const handleConfirmClearSelection = () => {
		onClearSelection();
		clearFilterStateStore();
		handleCancelAlert();
	};

	return (
		<>
			<ConfirmationDialog open={isOpenConfirmationDialog} onClose={handleCancelAlert} onConfirm={handleConfirmClearSelection} />
			<Button
				sx={{
					position: "absolute",
					top: "42px",
					right: "52px",
					"&:hover": {
						boxShadow: "0px 0px 6px 2px rgba(35,87,190,0.5)",
					},
				}}
				variant="contained"
				text="Clear Selection(s)"
				classes={` h-[30px] !rounded-[6px] btn-regular-text !normal-case !text-white " ${
					!hasFilteredItems ? "!bg-disabled" : "!bg-primary"
				}`}
				disabled={!hasFilteredItems}
				onClick={handleClearSelection}
			/>
		</>
	);
}

type ConfirmationDialogProps = Readonly<{
	open: boolean;
	onConfirm: () => void;
	onClose: () => void;
}>;

function ConfirmationDialog(props: ConfirmationDialogProps) {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			classes={{
				paper: "!rounded-[10px] py-4 pt-1 pr-4",
			}}
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<Typography className={"!font-sans !text-[14.5px] !text-[#666666] "}>
						This will clear all vehicle selections you have
						<br /> made across all tabs. Do you wish to continue?
					</Typography>
				</DialogContentText>
				<IconButton aria-label="close" onClick={onClose} classes={{ root: "!absolute !top-0 !right-0 !text-[#B3B3B3]" }}>
					<CloseIcon sx={{ fontSize: "18px" }} />
				</IconButton>
			</DialogContent>
			<DialogActions>
				<Stack direction="row" spacing={0.5} alignSelf={"flex-end"} mt={-1}>
					<MUIButton
						variant={"contained"}
						className="!h-[30px] !font-sans !normal-case !rounded-[6px] !text-white !mr-4 !bg-[#585B6D] !min-w-[85px] !shadow-none hover:!shadow-[0px_0px_6px_2px_rgba(88,91,109,0.50)]"
						onClick={onClose}
					>
						Cancel
					</MUIButton>
					<MUIButton
						variant={"contained"}
						className="!h-[30px] !font-sans !normal-case !rounded-[6px] !text-white !bg-primary !max-w-[85px]  !shadow-none hover:!shadow-[0_0_6px_2px_rgba(35,87,190,0.5)]"
						onClick={onConfirm}
					>
						Continue
					</MUIButton>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
